type AndroidViewMode = 'ar_preferred' | '3d_only' | '3d_preferred';

interface AndroidArConfig {
	title: string;
	fallbackUrl: string;
	mode?: AndroidViewMode;
	resizable?: boolean;
}

export function getAndroidArLink(src: string, config: AndroidArConfig): string {
	const { title, fallbackUrl, mode = 'ar_preferred', resizable = false } = config;

	return `intent://arvr.google.com/scene-viewer/1.0?file=${src}&title=${title}&mode=${mode}&resizable=${
		resizable ? 'true' : 'false'
	}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=${fallbackUrl};end;`;
}
